import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Alert } from 'react-bootstrap';
import Translation from '../../../../../components/stateless/Translation';
import CheckoutFormFieldText from '../CheckoutFormFieldText';
import CheckoutSubmitButton from '../CheckoutSubmitButton';
import circleCheckmark from './circle-checkmark.svg';

const propTypes = {
  appliedPromotion: PropTypes.shape(),
  checkingPromoCode: PropTypes.bool.isRequired,
  checkPromoCodeData: PropTypes.shape({
    success: PropTypes.bool.isRequired,
    discountPlanId: PropTypes.string,
  }),
  formSubmitType: PropTypes.string.isRequired,
  removeAppliedPromotion: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
};

const defaultProps = {
  checkPromoCodeData: undefined,
  appliedPromotion: undefined,
};

const ApplyPromotion = ({
  appliedPromotion,
  checkPromoCodeData,
  checkingPromoCode,
  formSubmitType,
  removeAppliedPromotion,
  submitting,
}) => {
  const [showPromoCode, setShowPromoCode] = useState(!!appliedPromotion);

  return (
    <Row>
      <Col xs={12} md={7}>
        {!showPromoCode ? (
          <div className="mb-5">
            <button className="underline pl-0" onClick={() => setShowPromoCode(true)} type="button">
              <Translation
                id="widgets.checkout.applyPromo.havePromoButton"
                defaultMessage="+ Have Promo Code?"
              />
            </button>
          </div>
        ) : null}
        {showPromoCode && !appliedPromotion ? (
          <div className="mb-5">
            {checkPromoCodeData && !checkPromoCodeData?.success ? (
              <Alert bsStyle="danger">
                <Translation
                  id={checkPromoCodeData.error}
                  defaultMessage="There was an error applying the promo code"
                />
              </Alert>
            ) : null}
            <div className="flex flex-row gap-3 items-center">
              <CheckoutFormFieldText
                name="promoCode"
                label={{
                  defaultMessage: 'Add Promo Code',
                  id: 'widgets.checkout.applyPromo.promoCodeLabel',
                }}
              />
              <CheckoutSubmitButton
                submitLabel={{
                  id: 'widgets.checkout.applyPromo.submitButton.submit',
                  defaultMessage: 'Apply',
                }}
                submitting={submitting || checkingPromoCode}
                submittingLabel={{
                  id: 'widgets.checkout.applyPromo.submitButton.submitting',
                  defaultMessage: 'Applying...',
                }}
                name="submitType"
                value={formSubmitType}
              />
            </div>
          </div>
        ) : null}
        {showPromoCode && appliedPromotion ? (
          <div className="mb-5">
            <div className="flex flex-row gap-2">
              <div>
                <img src={circleCheckmark} className="size-[20px]" alt="Promo applied" />
              </div>
              <div>
                <div>
                  {appliedPromotion.name}
                  <Translation
                    id="widgets.checkout.applyPromo.promoLabel"
                    defaultMessage=" - Promo Code"
                  />
                </div>
                <button className="underline pl-0" onClick={removeAppliedPromotion} type="button">
                  <Translation
                    id="widgets.checkout.applyPromo.removeButton"
                    defaultMessage="Remove"
                  />
                </button>
              </div>
            </div>
          </div>
        ) : null}
      </Col>
    </Row>
  );
};

ApplyPromotion.propTypes = propTypes;
ApplyPromotion.defaultProps = defaultProps;


export default ApplyPromotion;
